const CREDERE = window.CREDERE || {};

Object
  .keys(window.localStorage)
  .filter(i => /^credere:m:/.test(i))
  .forEach(i => window.localStorage.removeItem(i));

const environment = (window.CREDERE && window.CREDERE.environment);
const token = window.CREDERE && window.CREDERE.authorization;

/* eslint-disable no-underscore-dangle */
const user = JSON.parse((CREDERE._INTERNAL && CREDERE._INTERNAL.user) || null);
/* eslint-enable no-underscore-dangle */

export default {
  environment,
  token,
  user,
};
